import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/tariff/tariff.model';
import { useTranslation } from 'react-i18next';

export interface TariffTypeFilterStateControllerProps {
  value: TariffModel['type'];
  onRemove: FilteredItemProps['onRemove'];
}

export const TariffTypeFilterStateController = ({
  value,
  onRemove,
}: TariffTypeFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem
      icon="currency-euro-circle"
      label={t(`delmonicos-shared-sdk.enums-tariff-type.${value}`)}
      onRemove={onRemove}
    />
  );
};
